export default __webpack_public_path__ + "static/media/icon-skladniki roslinne i nabial.182cba34.svg";